import { osName, browserName, isIOS } from 'react-device-detect';

// 5.1.x 이상
export const isNativeApp = (userAgent: string) => /wcknewapp/.test(userAgent);

// 모든 앱
export const isNativeAppBoth = (userAgent: string) =>
  /wcknewapp|wckapp/.test(userAgent);

// 리팩토링 앱 검사. 5.3.x 이상
export const isNativeRefactoringApp = (userAgent: string) =>
  /wckrefapp/.test(userAgent);

// 구버전 App일때 ActionBar 위치조정 필요 여부. 5.1.x 이전 iphonex 앱
export const isOldNativeAppActionBar = (userAgent: string) =>
  /wckapp/.test(userAgent) &&
  /iphonex/.test(userAgent) &&
  !/wcknewapp/.test(userAgent);

// 홈바형식인 iphoneX 이상 기존 ActionBar 위치조정 필요 여부. 모든 앱에서 iphonex인 앱
export const isNativeAppActionBar = (userAgent: string) =>
  /wckapp/.test(userAgent) && /iphonex/.test(userAgent);

// 아이폰 X 앱
export const isIPhoneXApp = (userAgent: string) => /iphonex/.test(userAgent);

// 5.1.x, 5.2.x 까지인 앱
export const isNewNativeApp = (userAgent: string) =>
  /wcknewapp/.test(userAgent) && !/wckrefapp/.test(userAgent);

export const getOsName = () => osName;

export const getBrowserName = () => browserName;

export const getAppVesrion = (userAgent: string) => {
  if (userAgent?.includes('wckios')) {
    return userAgent
      ?.split(' ')
      .find(item => item.includes('wckios='))
      ?.replace('wckios=', '');
  }
  return userAgent
    ?.split(' ')
    .find(item => item.includes('wckand='))
    ?.replace('wckand=', '');
};

export const getAndroidMajorVersion = (): number | null => {
  if (typeof window === 'undefined') return null;
  const match = navigator.userAgent.match(/Android\s([0-9]+)/i);
  return match ? Number(match[1]) : null;
};

export const checkAppVersion = (appVer = '0.0.0', chackVer = '0.0.0') => {
  if (appVer === chackVer) {
    return 'same';
  }

  const appVers = appVer?.split('.');
  const chackVers = chackVer.split('.');

  let result = '';
  chackVers.some((val, index) => {
    // 현재 앱 버전 값
    const appVal = parseInt(`${appVers[index] || 0}`, 10);
    // 확인 할 버전 값
    const checkVal = parseInt(`${val || 0}`, 10);

    if (appVal > checkVal) {
      result = 'high';
      return true;
    }
    if (appVal < checkVal) {
      result = 'low';
      return true;
    }
    result = 'same';
    return false;
  });

  return result;
};
